import axios from "axios";
import { APIBaseUrl } from "./apiInterceptor";

export const userCreatePassword = async (payload) => {
  return await APIBaseUrl.post("/user/updatePassword", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findVacatedUsers = async (payload) => {
  return await APIBaseUrl.get("/admin/findAll/vacatedTenants", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const tenantDataUpdate = async (payload) => {
  return await APIBaseUrl.put("/admin/profile/updateprofile", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const createTenantCircular = async (payload) => {
  return await APIBaseUrl.post("/admin/tenantcircular/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const applyTenantPenalty = async (payload) => {
  return await APIBaseUrl.put("/admin/tenantcharges/apply/penalty", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllTenantCircular = async () => {
  return await APIBaseUrl.get("/admin/tenantcircular/findAll")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findTenantCircular = async (id) => {
  return await APIBaseUrl.get(`/admin/tenantcircular/findcircular?_id=${id}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const updateTenantCircular = async (payload) => {
  return await APIBaseUrl.put("/admin/tenantcircular/updatecircular", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const updateSocialMedia = async (payload) => {
  return await APIBaseUrl.put("/appConfiguration/update", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findSocialMedia = async (id) => {
  return await APIBaseUrl.get(`/admin/appconfiguration/find`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const deleteTenantCircular = async (payload) => {
  return await APIBaseUrl.delete(`/admin/tenantcircular/deletecircular`, {
    data: payload,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const UploadImage = async (Payload) => {
  return await APIBaseUrl.post(`/fileUpload`, Payload, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const createBookingManagement = async (payload) => {
  return await APIBaseUrl.post("/admin/bookingmanagement/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllBookingManagement = async (pgId, type, payment, status) => {
  return await APIBaseUrl.get(
    `/admin/bookingmanagement/findAll?pgId=${pgId}&payment=${payment}&status=${status}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllRoom = async (pgId = "", roomType = "") => {
  return await APIBaseUrl.get(
    `/admin/room/findAll?pgId=${pgId}&roomType=${roomType}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllRoomBed = async (pgId = "", roomId = "") => {
  return await APIBaseUrl.get(
    `/admin/bed/findAll?pgId=${pgId}&roomId=${roomId}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findBookingManagement = async (id) => {
  return await APIBaseUrl.get(
    `/admin/bookingmanagement/findparticular?_id=${id}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const updateBookingManagement = async (payload) => {
  return await APIBaseUrl.put("/admin/bookingmanagement/update", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const createAssetManagement = async (payload) => {
  return await APIBaseUrl.post("/admin/assetmanagement/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAssetManagement = async (payload) => {
  return await APIBaseUrl.get("/admin/assetmanagement/findparticular", {
    params: payload,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const updateAssetManagement = async (payload) => {
  return await APIBaseUrl.put("/admin/assetmanagement/update", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getMyFlatFacilities = async id => {
  return await APIBaseUrl.get(`/admin/pg/findpg?_id=${id}`)
    .then(response => response.data)
    .catch(err => err?.response?.data || err);
};

export const deleteAssetManagement = async (payload) => {
  return await APIBaseUrl.delete("/admin/assetmanagement/delete", {
    data: payload,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
// WIFI
export const createWifi = async (payload) => {
  return await APIBaseUrl.post("/admin/wifi/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllWifi = async () => {
  return await APIBaseUrl.get("/admin/wifi/findAll")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findWifi = async (payload) => {
  return await APIBaseUrl.get("/admin/wifi/findwifi", { params: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const updateWifi = async (payload) => {
  return await APIBaseUrl.put("/admin/wifi/updatewifi", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const deleteWifi = async (payload) => {
  return await APIBaseUrl.delete("/admin/wifi/deletewifi", { data: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
//room
export const createRoom = async (payload) => {
  return await APIBaseUrl.post("/admin/room/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllRooms = async (token, params) => {
  return await APIBaseUrl.get("/admin/room/findAll", {
    headers: { Authorization: `Bearer ${token}` },
    params,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findRoom = async (payload) => {
  return await APIBaseUrl.get("/admin/room/findroom", { params: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const updateRoom = async (payload) => {
  return await APIBaseUrl.put("/admin/room/updateroom", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const deleteRoom = async (payload) => {
  return await APIBaseUrl.delete("/admin/room/deleteroom", { data: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
//bed
export const createBedAllocation = async (payload) => {
  return await APIBaseUrl.post("/admin/bed/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllBedAllocation = async (params) => {
  return await APIBaseUrl.get("/admin/bed/findAll", { params })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findBedAllocation = async (payload) => {
  return await APIBaseUrl.get("/admin/bed/findparticular", { params: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const updateBedAllocation = async (payload) => {
  return await APIBaseUrl.put("/admin/bed/update", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const deleteBedAllocation = async (payload) => {
  return await APIBaseUrl.delete("/admin/bed/delete", { data: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const tenantBedAllocation = async (payload) => {
  return await APIBaseUrl.put("/admin/bed/allocate", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const updatetenantCashAccept = async (payload) => {
  return await APIBaseUrl.put(
    "/admin/bookingmanagement/tenantCashAccept",
    payload
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const createEmployees = async (payload) => {
  return await APIBaseUrl.post("/user/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const createTenantCharges = async (payload) => {
  return await APIBaseUrl.post("/admin/tenantcharges/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const updateTenantCharges = async (payload) => {
  return await APIBaseUrl.put("/admin/tenantcharges/updatecharges", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const deleteTenantCharges = async (payload, token) => {
  return await APIBaseUrl.delete(`/admin/tenantcharges/deletecharges`, {
    data: payload,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findTenantCharges = async (userId) => {
  return await APIBaseUrl.get(`/admin/tenantcharges/findAll?userId=${userId}&status=all`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findEbOthersCharges = async (tenantId) => {
  return await APIBaseUrl.get(
    `/admin/tenantcharges/findEbOthers?tenantId=${tenantId}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllPaymentsForTenant = async (userId) => {
  return await APIBaseUrl.get(`/admin/tenantcharges/findAll?userId=${userId}&status=all`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllTenantCharges = async (pgId, chargeStatus = "all") => {
  return await APIBaseUrl.get(
    `/admin/tenantcharges/findAll?status=${chargeStatus}&pgId=${pgId}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const createBranchTransaction = async (payload, token) => {
  return await APIBaseUrl.post("/admin/branchtransaction/create", payload, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllBranchTransactions = async (pgId) => {
  return await APIBaseUrl.get(`/admin/branchtransaction/findAll?pgId=${pgId}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
// pgId is always required, the rest are optional
export const filterBranchTransactions = async ({
  pgId,
  fromDate,
  toDate,
  month,
  transaction,
  payment,
}) => {
  const queryParams = [];
  queryParams.push(`pgId=${pgId}`);
  if (fromDate) queryParams.push(`fromDate=${fromDate}`);
  if (toDate) queryParams.push(`toDate=${toDate}`);
  if (month) queryParams.push(`month=${month}`);
  if (transaction) queryParams.push(`transactionType=${transaction}`);
  if (payment) queryParams.push(`paymentMode=${payment}`);

  const queryString = `?${queryParams.join("&")}`;

  return await APIBaseUrl.get(`/admin/branchtransaction/findAll${queryString}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllMessTransactions = async () => {
  return await APIBaseUrl.get(`/admin/messtransaction/findAll`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const filterMessTransactions = async ({
  fromDate,
  toDate,
  month,
  transaction,
  payment,
  category
}) => {
  const queryParams = [];
  if (month) queryParams.push(`month=${month}`);
  if (fromDate) queryParams.push(`fromDate=${fromDate}`);
  if (toDate) queryParams.push(`toDate=${toDate}`);
  if (transaction) queryParams.push(`transactionType=${transaction}`);
  if (payment) queryParams.push(`paymentMode=${payment}`);
  if (category) queryParams.push(`category=${category}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  return await APIBaseUrl.get(`/admin/messtransaction/findAll${queryString}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const createMessTransaction = async (payload) => {
  return await APIBaseUrl.post("/admin/messtransaction/create", payload)
    .then((res) => res.data)
    .catch((err) => err?.response?.data || err);
};
export const updateMessTransaction = async (payload) => {
  return await APIBaseUrl.put("/admin/messtransaction/update", payload)
    .then((res) => res.data)
    .catch((err) => err?.response?.data || err);
};

export const deleteMessTransaction = async (payload) => {
  return await APIBaseUrl.delete("/admin/messtransaction/delete", {
    data: payload,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const updateAdminTransaction = async (payload) => {
  return await APIBaseUrl.put("/admin/admintransaction/update", payload)
    .then((res) => res.data)
    .catch((err) => err?.response?.data || err);
};

export const deleteAdminTransaction = async (payload) => {
  return await APIBaseUrl.delete("/admin/admintransaction/delete", {
    data: payload,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const createIncomeExpenseCategory = async (payload) => {
  return await APIBaseUrl.post("/admin/incomecategory/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllIncomeExpenseCategory = async (
  pgId,
  collection,
  cashFlow
) => {
  return await APIBaseUrl.get(
    `/admin/incomecategory/findAll?pgId=${pgId}&collection=${collection}&cashFlow=${cashFlow}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllMessCategory = async (collection, cashFlow) => {
  return await APIBaseUrl.get(
    `/admin/incomecategory/findAll?collection=${collection}&cashFlow=${cashFlow}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllAuditCategory = async (cashFlow) => {
  return await APIBaseUrl.get(
    `/admin/incomecategory/findAll?cashFlow=${cashFlow}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllAdminTransactions = async () => {
  return await APIBaseUrl.get("/admin/admintransaction/findAll")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const filterAdminTransactions = async (params) => {
  return await APIBaseUrl.get("/admin/admintransaction/findAll", { params })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getDashboardData = async id => {
  return await APIBaseUrl.get(`/admin/pg/dashboard?pgId=${id}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getMessDashboardData = async id => {
  return await APIBaseUrl.get(`/admin/messtransaction/dashboard?pgId=${id}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const createAdminTransaction = async (payload) => {
  return await APIBaseUrl.post("/admin/admintransaction/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const getTenantRent = async (rentStatus, pgId) => {
  return await APIBaseUrl.get(
    `/user/rent/tenant?status=${rentStatus}&pgId=${pgId}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const getStaffTransaction = async (pgId, staffId) => {
  return await APIBaseUrl.get(
    `/admin/staffTransaction/findAll?pgId=${pgId}&staffId=${staffId}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const UpdateUser = async (Payload, token) => {
  return await APIBaseUrl.put("/user/updateUser", Payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const downloadBookingForm = async (_id) => {
  return await APIBaseUrl.get(`/admin/download/bookingForm?userId=${_id}`, {
    responseType: "blob",
  })
    .then((res) => res.data)
    .catch((err) => err?.response?.data || err);
};
export const cancelBooking = async (id) => {
  return await APIBaseUrl.get(`/admin/bookingmanagement/cancel?_id=${id}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const cancelRefundBooking = async (payload) => {
  return await APIBaseUrl.post(
    `/admin/bookingmanagement/cancelAndRefund`,
    payload
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findAllBranchDashboard = async (params) => {
  return await APIBaseUrl.get("/admin/branchtransaction/dashboard", { params })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllMessDashboard = async (params) => {
  return await APIBaseUrl.get("/admin/messtransaction/dashboard", { params })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllAdminDashboard = async (params) => {
  return await APIBaseUrl.get("/admin/admintransaction/dashboard", { params })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const userVerifyOtp = async (payload) => {
  return await APIBaseUrl.post("/user/verifyOTP", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const sentOtp = async (payload) => {
  return await APIBaseUrl.post("/user/resendOtp", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const userUpdatePassword = async payload => {
  return await APIBaseUrl.put('/user/updatePassword', payload)
    .then(response => response.data)
    .catch(err => err?.response?.data || err);
};

export const createAccount = async (payload) => {
  return await APIBaseUrl.post("/user/signUp", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const AdminLogin = async (payload) => {
  return await APIBaseUrl.post("/user/login", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const logOut = async (payload) => {
  return await APIBaseUrl.post("/user/logout", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const processStaffPayment = async (payload) => {
  return await APIBaseUrl.post("/user/staff/process", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const futureAvailableRooms = async (pgId, roomType, monthStr) => {
  return await APIBaseUrl.get(
    `/admin/room/futureAvailable?pgId=${pgId}&roomType=${roomType}&monthStr=${monthStr}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllFutureBookings = async (pgId) => {
  try {
    const response = await APIBaseUrl.get(
      `/admin/bookingmanagement/findAll?pgId=${pgId}&bookingType=futureBooking`
    );
    return response.data.data.data || []; // Extract the actual array of bookings
  } catch (err) {
    console.error("Fetch error:", err);
    return [];
  }
};
export const filterFutureBookings = async ({
  pgId,
  paymentMethod,
  fromDate,
  month,
}) => {
  try {
    if (!pgId) return [];
    const queryParams = [];
    queryParams.push(`pgId=${pgId}`);
    queryParams.push(`bookingType=futureBooking`);

    if (paymentMethod) queryParams.push(`type=${paymentMethod}`);
    if (fromDate) queryParams.push(`fromDate=${fromDate}`);
    if (month) queryParams.push(`month=${month}`);

    const queryString = `?${queryParams.join("&")}`;

    const response = await APIBaseUrl.get(
      `/admin/bookingmanagement/findAll${queryString}`
    );
    return response?.data?.data?.data || [];
  } catch (err) {
    console.error("FilterFutureBookings error:", err);
    return [];
  }
};

export const getStaffSalaryDetails = async (_id) => {
  return await APIBaseUrl.get(`/user/staff/salaryDetails?_id=${_id}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const userCreateMpin = async (payload) => {
  return await APIBaseUrl.post("/user/createMpin", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const userVerifyMpin = async (payload) => {
  return await APIBaseUrl.post("/user/verifyMpin", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const kyctenant = async (payload) => {
  return await APIBaseUrl.post("/user/kyctenant", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const createUser = async (payload) => {
  return await APIBaseUrl.post("/user/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const createMasterData = async (payload) => {
  return await APIBaseUrl.post("/admin/masterData/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findCategory = async (payload) => {
  return await APIBaseUrl.get(
    `/admin/masterData/findparticularcategory?category=${payload}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllMasterData = async () => {
  return await APIBaseUrl.get("/admin/masterData/findAll")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllCategory = async () => {
  return await APIBaseUrl.get("/admin/masterData/findAllCategory")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllAsset = async (token, payload) => {
  return await APIBaseUrl.get("/admin/assetmanagement/findAll", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllEnquiry = async () => {
  return await APIBaseUrl.get("/admin/enquiryform/findAll")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllFeedbacks = async () => {
  return await APIBaseUrl.get("/admin/feedback/findAll")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllTenant = async () => {
  return await APIBaseUrl.get("/admin/tenantprofile/findAll")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllTenantProfile = async () => {
  return await APIBaseUrl.get("/user/findAll/tenant")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllTenantsByPg = async (pgId) => {
  return await APIBaseUrl.get(
    `/user/findAll/tenant?start=0&limit=500&pgId=${pgId || ""}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllAuditReport = async () => {
  return await APIBaseUrl.get(`/admin/auditorReport`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findFilterAuditReport = async ({
  fromDate,
  toDate,
  month,
  transaction,
  payment,
  category
}) => {
  console.log('category_qwertyui', category)
  const queryParams = [];
  if (month) queryParams.push(`month=${month}`);
  if (fromDate) queryParams.push(`fromDate=${fromDate}`);
  if (toDate) queryParams.push(`toDate=${toDate}`);
  if (transaction) queryParams.push(`transactionType=${transaction}`);
  if (payment) queryParams.push(`paymentMode=${payment}`);
  if (category) queryParams.push(`category=${category}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

  return await APIBaseUrl.get(`/admin/auditorReport${queryString}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllKyc = async () => {
  return await APIBaseUrl.get("/admin/tenantkyc/findAll")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const UpdateKycState = async (payload) => {
  return await APIBaseUrl.put("/admin/tenantkyc/update", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const UpdateEnquiryForm = async (payload) => {
  return await APIBaseUrl.put("/admin/enquiryform/update", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllStaff = async () => {
  return await APIBaseUrl.get("/user/findAll/staff")
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findStaff = async (pgId) => {
  return await APIBaseUrl.get(`/user/findAll/staff?pgId=${pgId}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findSpecificUser = async (id) => {
  return await APIBaseUrl.get(`/user/findParticular?_id=${id}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllMaintenanceRequest = async (tenantId) => {
  return await APIBaseUrl.get(
    `/admin/maintenancerequest/findAll?tenantId=${tenantId}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllComplaints = async () => {
  return await APIBaseUrl.get(`/admin/maintenancerequest/findAll`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const updateMaintenanceRequest = async (_id, status) => {
  return await APIBaseUrl.put(`/admin/maintenancerequest/update`, {
    _id,
    status,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const createReplyComment = async (payload) => {
  return await APIBaseUrl.post(`/admin/replycomment/create`, payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const findReplyCommentsByMaintenanceId = async (maintenanceId) => {
  return await APIBaseUrl.get(
    `/admin/replycomment/findcomment?_id=${maintenanceId}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getTenantAgreementForm = async () => {
  return await APIBaseUrl.get(
    `/admin/cms/findparticular?sectionName=tenantAggrementForm`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getCMSSection = async (sectionName) => {
  return await APIBaseUrl.get(
    `/admin/cms/findparticular?sectionName=${sectionName}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const getCMSSectionContent = async (sectionName) => {
  return await APIBaseUrl.get(
    `/admin/cms/findparticular?sectionName=${sectionName}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getHeroSection = async () => {
  return await APIBaseUrl.get(
    `/admin/cms/findparticular?sectionName=heroSection`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getAboutUs = async () => {
  return await APIBaseUrl.get(`/admin/cms/findparticular?sectionName=aboutUs`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getPlatform1 = async () => {
  return await APIBaseUrl.get(`/admin/cms/findparticular?sectionName=platform1`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getPlatform2 = async () => {
  return await APIBaseUrl.get(`/admin/cms/findparticular?sectionName=platform2`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const getGetinTouch = async () => {
  return await APIBaseUrl.get(
    `/admin/cms/findparticular?sectionName=getInTouch`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const updateForm = async (payload) => {
  return await APIBaseUrl.put("/admin/cms/update", payload)
    .then((res) => res.data)
    .catch((err) => err?.response?.data || err);
};

export const createEnquiryForm = async (payload) => {
  return await APIBaseUrl.post("/admin/enquiryform/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findSpecificPg = async (id) => {
  return await APIBaseUrl.get(`/admin/pg/findpg?_id=${id}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findSpecificMasterData = async (id) => {
  return await APIBaseUrl.get(`/admin/masterData/findmasterData?_id=${id}`)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const CreateData = async (payload) => {
  return await APIBaseUrl.post("/admin/masterData/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const UpdatePassword = async (payload) => {
  return await APIBaseUrl.put("/user/updatePassword", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const UpdateData = async (payload) => {
  return await APIBaseUrl.put("/admin/masterData/updatemasterData", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const DeleteData = async (payload) => {
  return await APIBaseUrl.delete("/admin/masterData/deletemasterData", {
    data: payload,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllPG = async (payload) => {
  return await APIBaseUrl.get("/admin/pg/findAll", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const userFindAllPG = async (payload) => {
  return await APIBaseUrl.get("/user/pg/findAll", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const findAllParticularCategory = async (category) => {
  return await APIBaseUrl.get(
    `/admin/masterData/findparticularcategory?category=${category}`
  )
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const deleteUser = async (payload) => {
  return await APIBaseUrl.delete("/user/deleteUser", { data: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const DeletePG = async (payload) => {
  return await APIBaseUrl.delete("/admin/pg/deletepg", { data: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const DeleteEnquiry = async (payload) => {
  return await APIBaseUrl.delete("/admin/enquiryform/delete", { data: payload })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const CreatePG = async (payload) => {
  return await APIBaseUrl.post("/admin/pg/create", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const UpdatePG = async (payload) => {
  return await APIBaseUrl.put("/admin/pg/updatepg", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const updateSpecificTenant = async (payload) => {
  return await APIBaseUrl.put("/admin/updateSpecificTenant", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const updateSpecificTenantKyc = async (payload) => {
  return await APIBaseUrl.put("/admin/tenantkyc/updateByAdmin", payload)
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};
export const UploadMultipleImages = async (Payload) => {
  return await APIBaseUrl.post(`/fileUpload`, Payload, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

// ================================================================================================================================================
// ================================================================================================================================================

export const GetAllPGListingWithoutToken = async () => {
  return await axios
    .get(`${APIBaseUrl}/nonlogin/pgmanagement/listing`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
};

export const GetAllLinks = async () => {
  return await axios
    .get(`${APIBaseUrl}/User/CMS/findParticular?pageName=footer`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
};

export const contactus = async (Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/enquiryform/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const getTestimonials = async () => {
  const response = await axios
    .get(`${APIBaseUrl}/User/testimonial/find?status=Approved`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const getPageCms = async (name) => {
  const response = await axios
    .get(`${APIBaseUrl}/User/CMS/findParticular?pageName=${name}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const FindPrivacyPolicyTermsCondition = async (cmsDocumentType) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/nonUser/cmsDocument/findParticular?cmsDocumentType=${cmsDocumentType}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const getMealsByDay = async (pgId, day) => {
  const response = await axios
    .get(`${APIBaseUrl}/nonlogin/meal/listing?pgId=${pgId}&day=${day}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const getPgById = async (pgId, day) => {
  const response = await axios
    .get(`${APIBaseUrl}/nonlogin/pgmanagement/findParticular?pgId=${pgId}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const getMetaByPath = async (pathname) => {
  // console.log(pathname, "112");
  const response = await axios
    .get(`${APIBaseUrl}/nonUser/Metatag/findParticular?pageName=${pathname}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const AdminLogOut = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/user/logOut`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

//

export const GetAdminNotifications = async (token, params) => {
  return await APIBaseUrl.get("/appNotification/find", {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    params: params,
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const UpdateNotificationStatus = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/appNotification/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const DeleteAllNotification = async (Payload, token) => {
  console.log(Payload);
  const response = await axios
    .delete(`${APIBaseUrl}/appNotification/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const GetEmployeeListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/listing`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      console.log(response);
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetAdminListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Admin/employee/listing`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      console.log(response);
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetEmployeeCustomeNotification = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Employee/customNotification/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetCustomeNotification = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Employee/customNotification/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetSAASOwner = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/saas/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// * Admin Dashboard Count GET APIBaseUrl

export const GetAllDashboardCount = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/dashboard/count`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetAllDashboardIncomeExpense = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/dashboard/revenueGraph`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// * add

export const DeleteInventoryType = async (Payload, token) => {
  console.log(Payload);
  const response = await axios
    .delete(`${APIBaseUrl}/masterdata/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// export const GetInventoryList = async (token) => {
//   const response = await axios
//     .get(`${APIBaseUrl}/inventory/find?start=0&end=10`, {
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + token,
//       },
//     })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => ({ err: error }));
//   return response;
//}

// * Income and Expense
export const IncomeExpenseCreate = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/incomeexpense/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};
export const IncomeExpenseDelete = async (Payload, token) => {
  const response = await axios
    .delete(`${APIBaseUrl}/incomeexpense/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * lead

export const GetLeadList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/lead/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const GetLeadComments = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/leadComments/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const CreatePassword = async (Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/user/updatePassword`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const CreateOtp = async (Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/user/verifyOTP`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const CreateNewPassword = async (Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/user/setNewPassWord`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const RoleManagementOwned = async (token, status, ownerId) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/employeerole/listing?status=${status}&userType=Employee&ownerId=${ownerId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const RoleManagement = async (token, status) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/employeerole/listing?status=${status}&userType=Employee`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const AdminRoleManagement = async (token, status, userType) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/employeerole/listing?status=${status}&userType=${userType}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const CustomeRoleMangement = async (token, status) => {
  const response = await axios
    .get(
      `${APIBaseUrl}customNotification/find?createdBy=650ee23e1dc99e97ac0a1034${status}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const CreateEmployeeRole = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employeerole/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const RoleDelete = async (Payload, token) => {
  const response = await axios
    .delete(
      `${APIBaseUrl}/employeerole/delete`,
      {
        data: Payload,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const RoleDetails = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/employeerole/findparticular?_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateRole = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/employeerole/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetMasterDataDesignation = async (token, type) => {
  const response = await axios
    .get(`${APIBaseUrl}/masterdata/listing?type=${type}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const CreateMasterDataDesignation = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/masterdata/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const CreateEmployee = async (payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/user/create`, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const DeleteEmployee = async (Payload, token) => {
  const response = await axios
    .delete(
      `${APIBaseUrl}/employee/delete`,
      {
        data: Payload,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const EmployeeDetailsSpecific = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/findparticular?userId=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const UserDetailsSpecific = async (token, id) => {
  return APIBaseUrl.get(`/user/findParticular?_id=${id}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const UpdateEmployee = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/employee/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateTenant = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/tenantProfile/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UserPasswordUpdate = async (Payload, token) => {
  return APIBaseUrl.put(`/user/changePassword`, Payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

//Craete Leave Master Type

export const CreateLeaveMaster = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/masterdata/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get all Leave master

export const GetAllLeaveMaster = async (token, status) => {
  const response = await axios
    .get(`${APIBaseUrl}/masterdata/listing?status=${status}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetAllLeaveMasterWithoutStatus = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/masterdata/listing`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Leave Master Specific

export const LeaveMasterDetails = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/masterdata/findparticular?_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Leave Master

export const UpdateLeaveMaster = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/masterdata/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const LeaveMasterDelete = async (Payload, token) => {
  const response = await axios
    .delete(
      `${APIBaseUrl}/masterdata/delete`,
      {
        data: Payload,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get all Leave

export const GetAllLeave = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/leave/find?user=admin&pgId=all`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ erroror: error }));
  return response;
};

//Craete Leave

export const CreateLeave = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/leave/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const CreateAdminLeave = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/admin/leave/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get all PG

export const GetAllPG = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/pgmanagement/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Leave Specific

export const LeaveDetailSpecific = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/leave/findParticular?leave_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Leave

export const UpdateLeave = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/leave/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// Get all notice

export const GetAllNotice = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/employeeNotice/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetAllNoticeWithStatus = async (token, status, id) => {
  const response = await axios
    .get(
      `${APIBaseUrl}/employeeNotice/find?status=${status}&employeeId=${id}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Craete employee notice

export const CreateEmployeeNotice = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employeeNotice/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Notice Specific

export const NoticeDetailSpecific = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/employeeNotice/findParticular?id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Update Notice

export const UpdateNotice = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/employeeNotice/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetMasterDataWithStatus = async (token, status) => {
  const response = await axios
    .get(`${APIBaseUrl}/masterdata/listing?status=${status}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateMasterData = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/masterdata/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetByType = async (params, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/masterdata/listing`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * add
export const CreateByType = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/masterdata/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};
// export const DeleteInventoryType = async (Payload, token) => {
//   console.log(Payload);
//   const response = await axios
//     .delete(`${APIBaseUrl}/masterdata/delete`, {
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: "Bearer " + token,
//       },
//       data: Payload,
//     })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => ({ err: error }));
//   return response;
// };

// * edit
export const EditMasterDataValue = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/masterdata/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const GetPG = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/pgmanagement/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * Inventory List
export const CreateInventoryList = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/inventory/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const GetInventoryList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/inventory/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const UpdateInventoryList = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/inventory/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};
export const DeleteInventoryList = async (Payload, token) => {
  const response = await axios
    .delete(`${APIBaseUrl}/inventory/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const IncomeExpenseUpdate = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/incomeexpense/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * Specific CMS
export const GetSpecificCMS = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Admin/CMS/findParticular`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * Specific CMS Update
export const UpdateSpecificCMS = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/Admin/CMS/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// * Banner List
export const GetAllBannerList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Banner/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * FAQ List
export const GetAllFAQList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/FAQ/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Create FAQ List

// * Income and Expense
export const CreateFAQ = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/FAQ/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Delete FAQ List

export const DeleteFAQ = async (Payload, token) => {
  const response = await axios
    .delete(`${APIBaseUrl}/FAQ/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Update FAQ List

export const UpdateFAQ = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/FAQ/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * Testimonials List
export const GetAllTestimonalsList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Admin/testimonial/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Testimonial Status Update

export const UpdateTestimonials = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/Admin/testimonial/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// * Income and Expense
export const IncomeExpenseFind = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/incomeexpense/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * lead

// * Inventory List
export const CreateLeadList = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/lead/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * Inventory List
export const UpdateLeadList = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/lead/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const DeleteLeadList = async (Payload, token) => {
  const response = await axios
    .delete(`${APIBaseUrl}/lead/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const LeadFindOne = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/lead/findParticular?lead_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
// * meal

export const MealCreate = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/meal/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const MealFind = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/meal/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const MealUpdate = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/meal/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const MealDelete = async (Payload, token) => {
  const response = await axios
    .delete(`${APIBaseUrl}/meal/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * room
export const FindRoom = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/roomManagement/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      console.log(response);
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};
export const CreateRoom = async (payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/roomManagement/create`, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer" + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const UpdateRoom = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/roomManagement/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const RoomDelete = async (Payload, token) => {
  const response = await axios
    .delete(`${APIBaseUrl}/roomManagement/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * attendance api list

export const FindAttendance = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/attendance/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const GetRoomCleaningList = async (params, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/roomcleaning/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const CreateRoomCleaningList = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/roomcleaning/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const UpdateRoomCleaningList = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/roomcleaning/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const DeleteRoomCleaningList = async (Payload, token) => {
  const response = await axios
    .delete(
      `${APIBaseUrl}/roomcleaning/delete`,
      {
        data: Payload,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const RoomCleaningDetailsSpecific = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/roomcleaning/findParticular?_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UploadDocument = async (Payload) => {
  return APIBaseUrl.post("/fileUpload", Payload, {
    headers: { "Content-Type": "multipart/form-data" },
  })
    .then((response) => response.data)
    .catch((err) => err?.response?.data || err);
};

export const GetAllPGListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/admin/pg/findAll`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      //
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetAllEnquiries = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/admin/enquiryform/findAll`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateEnquires = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/enquiryform/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const GetTenantListing = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/tenantProfile/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const DeleteTenant = async (Payload, token) => {
  const response = await axios
    .delete(`${APIBaseUrl}/tenantProfile/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetSpecificTenantListing = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/tenantProfile/findParticular?userId=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetSosSpecificEmployee = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/sos/adminList`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetPollResponseListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/PollResponse/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetPollVisitsListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Pollvisit/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetPaymentListing = async (token, userId) => {
  const response = await axios
    .get(`${APIBaseUrl}/paymentHistory/find?tenantId=${userId}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetAllPaymentListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/paymentHistory/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetSpecificPGDetails = async (params, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/pgmanagement/findparticular`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Get all cms

export const GetAllCMS = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/cmsDocument/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//cms Specific

export const CMSDetailSpecific = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/cmsDocument/findParticular?_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//Create cms

export const CreateCMS = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/cmsDocument/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// update cms
export const UpdateCMS = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/cmsDocument/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Get all compliant management

export const GetAllCM = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/complaintManagement/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//compliant management Specific

export const CMDetailSpecific = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/complaintManagement/findParticular?_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// update compliant management
export const UpdateCM = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/complaintManagement/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Get all comment

export const GetAllComment = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/complaintComments/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// create comment
export const CreateEmployeeNoticeComment = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/employeeNoticeComments/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const CreateComment = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/complaintComments/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// * Wastefood find

export const GetWasteFood = async (params, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/wastefood/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const PGDetailsSpecific = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/pgmanagement/findparticular?_id=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdatePg = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/pgmanagement/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// * Tanent
// * Payment History

export const GetPaymentList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/paymentHistory/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetRomeCleaningList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/roomcleaning/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// export const GetFoodList = async (token, params) => {
//   const response = await axios
//     .get(`${APIBaseUrl}/tenantfood/find`, {
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//       params,
//     })
//     .then((response) => {
//       return response.data;
//     })
//     .catch((error) => ({ error: error }));
//   return response;
// };

export const GetFoodList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/tenantfood/tenantFoodListing`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetTenantComplaintList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/complaintManagement/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetCommentsComplaintList = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/complaintComments/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetCommentsForEmployeeNotice = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/employeeNoticeComments/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetCommentsForRoomNotice = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/RoomComments/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetSpecificTenantDetails = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/tenantProfile/findParticular`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetSpecificTenantDocuments = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Employee/profileDocuments/findParticular`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetTenantNotice = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/RoomNotice/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetNotice = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/RoomNotice/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetSpecificPollDetails = async (params, token) => {
  console.log(params);
  const response = await axios
    .get(`${APIBaseUrl}/Poll/findParticular`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetInOutlist = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/accesstenant/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetPollListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/Poll/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

// * create notice comment
export const CreateNoticeComments = async (payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/RoomComments/create`, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetTenantFood = async (payload, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/tenantfood/find`, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const PollCreate = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/Poll/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const PollDelete = async (Payload, token) => {
  const response = await axios
    .delete(`${APIBaseUrl}/Poll/delete`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      data: Payload,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const PollUpdate = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/Poll/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

export const GetRoomInventory = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/roomInventory/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const CreateRoomInventory = async (token, Payload) => {
  const response = await axios
    .post(`${APIBaseUrl}/roomInventory/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateRoomInventory = async (token, Payload) => {
  const response = await axios
    .put(`${APIBaseUrl}/roomInventory/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetRoomCleaning = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/roomcleaning/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetTenantProfile = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/tenantProfile/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetSpecificEmployeeDetails = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/employee/findparticular`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetEmployeeLeaveListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/leave/find?user=admin&status=all&pgId=all`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetEmployeeAttendance = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/attendance/employeeBasedAttendance`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetParticularEmployeeAttendance = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/attendance/particularEmployeeAttendance`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetParticularDateAttendance = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/attendance/particularDateAttendance`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

//SAAS Owners

export const GetAllOwnersListing = async (token, params) => {
  const response = await axios
    .get(`${APIBaseUrl}/saas/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const CreateOwners = async (payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/saas/create`, payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateOwners = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/saas/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const OwnerDetailsSpecific = async (token, id) => {
  const response = await axios
    .get(`${APIBaseUrl}/saas/findParticular?userId=${id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const DeleteOwners = async (Payload, token) => {
  const response = await axios
    .delete(
      `${APIBaseUrl}/saas/delete`,
      {
        data: Payload,
      },
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetSpecificOwnerDetails = async (params, token) => {
  const response = await axios
    .get(`${APIBaseUrl}/saas/findParticular`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
      params,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Banner Create

// * add
export const CreateBanner = async (Payload, token) => {
  const response = await axios
    .post(`${APIBaseUrl}/Banner/create`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// Update Banner

export const UdpateBanner = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/Banner/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};

// *Booking Block APIBaseUrl
export const GetAllBookingBlock = async (token, user, pgId) => {
  const response = await axios
    .get(`${APIBaseUrl}/bookingblock/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        user: user,
        pgId: pgId,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetAllBookingBlock1 = async (token, user) => {
  const response = await axios
    .get(`${APIBaseUrl}/bookingblock/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        // status:status,
        user: user,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
// WIFI MANAGEMENT
export const GetAllWifiManagement = async (token, pgId) => {
  const response = await axios
    .get(`${APIBaseUrl}/wifimanagement/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        pgId: pgId,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};
export const GetAllWifiManagement2 = async (token, createdBy) => {
  const response = await axios
    .get(`${APIBaseUrl}/wifimanagement/find`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      params: {
        createdBy: createdBy,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const GetAllScheduleVisit = async (token) => {
  const response = await axios
    .get(`${APIBaseUrl}/schedulevisit/find?user=admin&status=all`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ error: error }));
  return response;
};

export const UpdateScheduleVisit = async (Payload, token) => {
  const response = await axios
    .put(`${APIBaseUrl}/schedulevisit/update`, Payload, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => ({ err: error }));
  return response;
};
